import moment from "moment";
import React from "react";
import { Col, Row, Card } from "react-bootstrap";
import Buttons from "../../components/Form/Button";
import payrollInfoIcon from "../../assets/images/payroll_info.svg";
import "./style.scss";
// import Select from "react-select";
// import CommonButton from "../../components/commonButton";
// import { postData } from "../../api";
// import { toast } from "react-toastify";
// import { autocloseTiming } from "../../api/regex";
// import PayrollPreview from "../PayrollPreview";

export default function RunPayRollInfo(props) {
  const {
    auto_refresh,
    processPayrollList,
    lastRegularCycleEntry,
    loading,
    handleStageChange,
    completePayrollData,
    lastOffCycleEnty,
    individualInfoText,
    runPayrollLink,
    // selectedPeriod,
    // setSelectedPeriod,
  } = props;

  // const [userInfo, setUserInfo] = useState({});
  // const [payrollData, setPayrollData] = useState({});
  // const [dropdownLoader, setDropdownLoader] = useState(false);
  // const [btnLoading, setBtnLoading] = useState(false);
  // const [showModal, setShowModal] = useState(false);
  // const [previewData, setPreviewData] = useState(null);

  // Convert object into array of {value, label}
  // const payPeriodOptions =
  //   payrollData &&
  //   Object.values(payrollData)
  //     .map((period) => {
  //       if (!period) return null;
  //       return {
  //         value: period.payroll_uuid,
  //         label: `${moment(period.start_date).format("MM-DD-YYYY")} to ${moment(
  //           period.end_date
  //         ).format("MM-DD-YYYY")}`,
  //       };
  //     })
  //     .filter(Boolean);
  // const handleChange = (selectedOption) => {
  //   setSelectedPeriod(selectedOption);
  // };
  function formatDate(dateString) {
    const formattedDate = moment(dateString, "DD-MM-YYYY HH:mm:ss").format(
      "MM-DD-YYYY"
    );
    return formattedDate;
  }
  // const handleGetUserInfo = async () => {
  //   const res = await postData("get_user_details", {}, {});
  //   try {
  //     if (res?.status === true) {
  //       setUserInfo(res.data);
  //     }
  //   } catch (err) {
  //     console.log(err);
  //   }
  // };
  // const handleGetOptions = async () => {
  //   setDropdownLoader(true);
  //   const payLoad = {
  //     flow_type: "dropdown",
  //     client_id: userInfo?.client_id,
  //     user_id: userInfo?.user_id,
  //   };
  //   const res = await postData("payroll_preview", {}, payLoad);
  //   try {
  //     if (res?.status === true) {
  //       setPayrollData(res?.data || []);
  //     } else {
  //       toast.error(res.message, {
  //         theme: "colored",
  //         autoClose: autocloseTiming,
  //       });
  //     }
  //   } catch (err) {
  //     console.log(err);
  //     toast.error(res.message, {
  //       theme: "colored",
  //       autoClose: autocloseTiming,
  //     });
  //   } finally {
  //     setDropdownLoader(false);
  //   }
  // };

  // useEffect(() => {
  //   handleGetUserInfo();
  // }, []);

  // useEffect(() => {
  //   if (userInfo?.client_id) {
  //     handleGetOptions();
  //   }
  // }, [userInfo?.client_id]);

  // const handlePreparePayroll = async () => {
  //   setBtnLoading(true);
  //   const payLoad = {
  //     flow_type: "preview",
  //     client_id: userInfo?.client_id,
  //     gusto_payroll_uuid: selectedPeriod?.value,
  //     user_id: userInfo?.user_id,
  //   };
  //   const res = await postData("payroll_preview", {}, payLoad);
  //   try {
  //     if (res?.status === true && res?.data?.employee_compensations) {
  //       setPreviewData(res?.data);
  //       setShowModal(true);
  //       // sessionStorage.setItem("payrollPreviewData", JSON.stringify(res?.data));
  //       // window.open("/payroll-preview", "_blank");
  //     } else {
  //       toast.error(res?.message, {
  //         theme: "colored",
  //         autoClose: autocloseTiming,
  //       });
  //     }
  //   } catch (err) {
  //     console.log(err);
  //     toast.error("Failed to prepare payroll", {
  //       theme: "colored",
  //       autoClose: autocloseTiming,
  //     });
  //   } finally {
  //     setBtnLoading(false);
  //   }
  // };

  return (
    <>
      <>
        {!completePayrollData.isfirstpayroll_run ? (
          <>
            {runPayrollLink && individualInfoText.regular && (
              <>
                <div className="exiting-payroll mb-3 px-1">
                  <div className="header mb-3">
                    <Row>
                      <Col md={12}>
                        <Card>
                          <Card.Header>
                            Prepare regular cycle payroll
                          </Card.Header>
                          <Card.Body>
                            <Card.Text className=" m-0">
                              <div className="d-flex w-100 align-items-center m-0 justify-content-space-between mb-6">
                                {processPayrollList.length ? (
                                  <div className="heading f-18 w-75">
                                    Recent process request was done by{" "}
                                    <span>
                                      &nbsp;{lastRegularCycleEntry?.name}&nbsp;
                                    </span>{" "}
                                    on
                                    <span>
                                      &nbsp;
                                      {formatDate(
                                        lastRegularCycleEntry?.payroll_processing_date
                                      )}
                                      &nbsp;
                                    </span>
                                    . Do you want to start the preparation
                                    process again?
                                  </div>
                                ) : (
                                  <p className="p-0 m-0 heading f-18">
                                    Your regular cycle payroll is successfully
                                    prepared. You can proceed to process and run
                                    it now.
                                  </p>
                                )}
                                <Buttons
                                  type="button"
                                  className="btn-primary text-white float-right prepare-btn"
                                  disabled={auto_refresh}
                                  loading={loading}
                                  onClick={() =>
                                    handleStageChange("run_payroll")
                                  }
                                >
                                  PREPARE PAYROLL
                                </Buttons>
                              </div>
                            </Card.Text>
                            {auto_refresh && individualInfoText.regular && (
                              <div className="waiting-text text-left payroll-data-info-container">
                                <img
                                  src={payrollInfoIcon}
                                  alt="payroll_icon"
                                  className="me-2"
                                />
                                Payroll is processing. This may take under few
                                mins please wait!
                              </div>
                            )}
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                </div>
                {/* <div className="exiting-payroll mb-3 px-1">
                  <div className="header mb-3 preview-employee-payroll-details">
                    <div className="preview-employee-title">
                      <h5>Preview employee’s payroll details</h5>
                      <p>
                        Review before you run payroll - Select a pay period to
                        preview the payroll journal report for all employees
                        before processing.
                      </p>
                    </div>
                    <div className="preview-employee-btn-wrapper">
                      <div>
                        <div>
                          <Select
                            options={payPeriodOptions}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            placeholder="Select pay period"
                            value={selectedPeriod}
                            onChange={handleChange}
                            onMenuOpen={handleGetOptions}
                            isLoading={dropdownLoader}
                          />
                        </div>
                      </div>
                      <div>
                        <CommonButton
                          variant="primary"
                          btnText="Preview"
                          fontWeight="400"
                          onClick={dropdownLoader ? null : handlePreparePayroll}
                          isLoading={btnLoading}
                          disabled={selectedPeriod === null || dropdownLoader}
                        />
                      </div>
                    </div>
                  </div>
                </div> */}
              </>
            )}
          </>
        ) : (
          <>
            {" "}
            {runPayrollLink && individualInfoText.regular && (
              <div className="prepare-run-wrapper">
                <div className="prepare-run-sub-wrapper">
                  <div className="w-75">
                    <div className="prepare-run-text-wrapper">
                      <h3>Regular cycle payroll</h3>
                      <p>
                        These are processed according to the scheduled pay
                        periods for the selected pay frequency, ensuring
                        employees are paid consistently and on time.
                      </p>
                    </div>
                    <div className="prepare-run-text-wrapper">
                      <h3>Here’s what happens when you run payroll:</h3>
                      <ul>
                        <li>
                          Employee hours and PTO are automatically pulled from
                          timekeeping (if enabled).
                        </li>
                        <li>
                          Salaries, taxes, and deductions are calculated
                          accurately.
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="prepare-run-btn-wrapper">
                    <Buttons
                      type="button"
                      className="btn-primary text-white float-right prepare-btn"
                      disabled={auto_refresh}
                      loading={loading}
                      onClick={() => handleStageChange("run_payroll")}
                    >
                      PREPARE PAYROLL
                    </Buttons>
                  </div>
                </div>
                {/* <div className="exiting-payroll mb-3 px-1">
                  <div className="header mb-3 preview-employee-payroll-details">
                    <div className="preview-employee-title">
                      <h5>Preview employee’s payroll details</h5>
                      <p>
                        Review before you run payroll - Select a pay period to
                        preview the payroll journal report for all employees
                        before processing.
                      </p>
                    </div>
                    <div className="preview-employee-btn-wrapper">
                      <div>
                        <div>
                          <Select
                            options={payPeriodOptions}
                            closeMenuOnSelect={true}
                            hideSelectedOptions={false}
                            placeholder="Select pay period"
                            value={selectedPeriod}
                            onChange={handleChange}
                          />
                        </div>
                      </div>
                      <div>
                        <CommonButton
                          variant="primary"
                          btnText="Preview"
                          fontWeight="400"
                          onClick={dropdownLoader ? null : handlePreparePayroll}
                          isLoading={btnLoading}
                          disabled={selectedPeriod === null || dropdownLoader}
                        />
                      </div>
                    </div>
                  </div>
                </div> */}
              </div>
            )}
          </>
        )}
        {!completePayrollData.isfirstpayroll_off ? (
          <>
            {runPayrollLink && individualInfoText.offCycle && (
              <div className="exiting-payroll mb-3 px-1">
                <div className="header mb-3">
                  <Row>
                    <Col md={12}>
                      <Card>
                        <Card.Header>Prepare off cycle payroll</Card.Header>
                        <Card.Body>
                          <Card.Text className=" m-0">
                            <div className="d-flex w-100 align-items-center m-0 justify-content-space-between mb-6">
                              {processPayrollList.length ? (
                                <div className="heading f-18 w-75">
                                  Recent process request was done by{" "}
                                  <span>
                                    &nbsp;{lastOffCycleEnty?.name}&nbsp;
                                  </span>{" "}
                                  on
                                  <span>
                                    &nbsp;
                                    {formatDate(
                                      lastOffCycleEnty?.payroll_processing_date
                                    )}
                                    &nbsp;
                                  </span>
                                  . Do you want to start the preparation process
                                  again?
                                </div>
                              ) : (
                                <p className="p-0 m-0 heading f-18">
                                  Your off cycle payroll is successfully
                                  prepared. You can proceed to process and run
                                  it now.
                                </p>
                              )}
                              <Buttons
                                type="button"
                                className="btn-primary text-white float-right prepare-btn"
                                disabled={auto_refresh}
                                loading={loading}
                                onClick={() =>
                                  handleStageChange("run_off_cycle_payroll")
                                }
                              >
                                PREPARE PAYROLL
                              </Buttons>
                            </div>
                          </Card.Text>
                          {auto_refresh && individualInfoText.offCycle && (
                            <div className="waiting-text text-left payroll-data-info-container">
                              <img
                                src={payrollInfoIcon}
                                alt="payroll_icon"
                                className="me-2"
                              />
                              Payroll is processing. This may take under few
                              mins please wait!
                            </div>
                          )}
                        </Card.Body>
                      </Card>
                    </Col>
                  </Row>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            {" "}
            {runPayrollLink && individualInfoText.offCycle && (
              <div className="prepare-run-sub-wrapper">
                <div className="w-75">
                  <div className="prepare-run-text-wrapper">
                    <h3>Off cycle payroll</h3>
                    <p>
                      These are processed outside the regular payroll cycle,
                      allowing you to handle payments for specific dates and
                      employees, such as bonuses, corrections, or special
                      payouts.
                    </p>
                  </div>
                  <div className="prepare-run-text-wrapper">
                    <h3>
                      Here’s what happens when you run an off cycle payroll:
                    </h3>
                    <ul>
                      <li>
                        Employee hours and PTO are automatically pulled from
                        timekeeping (if enabled).
                      </li>
                      <li>
                        Salaries, taxes, and deductions are calculated
                        accurately.
                      </li>
                    </ul>
                  </div>
                </div>
                <div className="prepare-run-btn-wrapper">
                  <Buttons
                    type="button"
                    className="btn-primary text-white float-right prepare-btn"
                    disabled={auto_refresh}
                    loading={loading}
                    onClick={() => handleStageChange("run_off_cycle_payroll")}
                  >
                    PREPARE PAYROLL
                  </Buttons>{" "}
                </div>
              </div>
            )}
          </>
        )}
      </>
      {/* {showModal && (
        <Modal
          show={showModal}
          onHide={() => setShowModal(false)}
          centered
          className="modal-payroll-preview"
        >
          <Modal.Header closeButton>
            <Modal.Title>Payroll Preview</Modal.Title>
          </Modal.Header>
          <PayrollPreview employeeData={previewData} />
        </Modal>
      )} */}
    </>
  );
}
